export const SOCIAL = {
    twitterhandler: "@playfinderUK",
};
